import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Report } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';
import { queryClient } from '../queryClient';

interface HookProps {
  report: Partial<Report>;
}

const triggerFileDownload = (response: Blob, fileName: string) => {
  const href = window.URL.createObjectURL(response);
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadReportFile = async (report: Partial<Report>) => {
  const toastId = toast.loading('Downloading report ...');

  try {
    const response = await request({
      path: `reports/download/${report._id}`,
      method: 'POST',
      authenticate: true,
      fileDownload: true,
    });

    triggerFileDownload(response, report.file.fileName);

    toast.update(toastId, {
      render: 'Successfully downloaded the report!',
      type: 'success',
      isLoading: false,
      autoClose: 5000,
    });
  } catch (error) {
    toast.update(toastId, {
      render: 'Error downloading the report!',
      type: 'error',
      isLoading: false,
      autoClose: 5000,
    });
    throw error;
  }
};

export const useDownloadReportFile = () => {
  // TODO - use report type for messages
  return useMutation({
    mutationFn: async ({ report }: HookProps) => {
      await downloadReportFile(report);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the report!');
    },
  });
};
